module.exports = __webpack_public_path__ + "img/web3icon7.724850d8.png";